// extracted by mini-css-extract-plugin
export default {"doneBtn":"DirectEmbedPayment_doneBtn__a5JBB","payFields":"DirectEmbedPayment_payFields__Vsqpg"};